module.exports = __webpack_public_path__ + "static/media/login.28837c57.svg";